import BetsSettingsPartContainer from "@baseUI/component/settings/BetsSettingsPartContainer";

export default class BetsSettingsPartContainerDesktop extends BetsSettingsPartContainer {

    constructor(params) {
        super(params)
    }

    setParametersSizePosition(params){
        this.param = {
            panelPopupPosition: {x: 0, y: 0},
            betsCaptionPosition: params.captionPosition,
            lineCaption: {x1: -100, y1: 100, x2: 1200, y2: 100 },
            countRow: 5,
            settingsBtn: {width: 220, height: 130, spaceX: 40, spaceY: 50, startX: 50, startY: 230},
        }
    }
}
